/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, {useContext} from 'react';

import {View, StyleSheet,Image} from 'react-native';

//@ts-ignore
import NOMAP from '../../../../../../assets/res/images/noMap.svg';
import {useTheme} from '../../../../../../providers/theme';
import {LOCATION_NOT_FOUND} from '../../../../../../assets/images';
import {TextVW} from '@vlinder-web/text-vfw-widget-react';

interface INoMap {
  title?: string;
  isSvgIcon?: boolean;
  subTitle?: string;
}

export const NoMap = (props: INoMap) => {
  const {title, isSvgIcon, subTitle} = props;
  const theme = useTheme();

  const _renderTitle = () => {
    if (title && typeof title === 'string') {
      return (
        <TextVW
          type={'body'}
          align={'center'}
          children={title}
          style={StyleSheet.flatten([
            styles.textStyle,
            {color: theme?.colors?.greyDark},
          ])}
        />
      );
    }
  };

  const _renderSubTitle = () => {
    if (subTitle && typeof subTitle === 'string') {
      return (
        <TextVW
          type={'subhead'}
          align={'center'}
          children={subTitle}
          style={StyleSheet.flatten([
            styles.subTextStyle,
            {color: theme?.colors?.greyDark},
          ])}
        />
      );
    }
  };

  const _renderIcon = () => {
    if (isSvgIcon && typeof isSvgIcon === 'boolean') {
      return <NOMAP width={150} height={200} />;
    } else {
      return (
        // <FastImage
        //   source={LOCATION_NOT_FOUND}
        //   resizeMode={FastImage.resizeMode.contain}
        //   style={StyleSheet.flatten([styles.imageStyle])}
        // />
        <Image
         source={LOCATION_NOT_FOUND}
         resizeMode={"contain"}
         style={StyleSheet.flatten([styles.imageStyle])}
        />
      );
    }
  };

  return (
    <View style={StyleSheet.flatten([styles.container])}>
      {_renderIcon()}
      {_renderTitle()}
      {_renderSubTitle()}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
  },
  textStyle: {
    fontSize: 15,
    marginBottom: 10,
    letterSpacing: 2,
    fontWeight: '500',
  },
  subTextStyle: {
    fontSize: 11,
    marginBottom: 10,
  },
  imageStyle: {
    width: 120,
    height: 120,
    alignSelf: 'center',
    marginTop: 40,
    marginBottom: 10,
  },
});

NoMap.defaultProps = {
  isSvgIcon: false,
  title: 'Oops!... Location Not Available',
  subTitle: 'Sorry, We do not have the location for this provenance step',
} as Partial<INoMap>;
